import React from "react";
import { component_tool, utils_tool } from '@/tool';
import moment from 'moment'
import QRCode from 'qrcode.react';
let { WizModal, } = component_tool;
import { WizTableForm } from '@/containers/common';
import { WizDataAuthSelect } from '@/containers/common';
import HighSet from "@/containers/common/highSet";

//配置项
let componentName = 'courseApplication'


const columns = [
  {
    name: "id",
    formItem: {
      type: "hidden"
    }
  },
  {
    title: "课程名称",
    name: "programNameSearch",
    dataIndex: "programNameSearch",
    searchItem: {},
  },
  {
    title: "课程名称",
    name: "programName",
    dataIndex: "programName",
    tableItem: {}
  },
  {
    title: "课程编码",
    name: "programScoId",
    searchItem: {},
    dataIndex: "programScoId",
    tableItem: {}
  },
  {
    title: "申请类型",
    name: "applyType",
    dataIndex: "applyType",
    searchItem: { type: "select" },
    tableItem: {},
    dict: [
      { code: 0, codeName: "新课程申请" },
      { code: 1, codeName: "课程内容更新" },
      { code: 2, codeName: "初始课程" },
    ],
  },
  {
    title: "新版本号",
    name: "versionNumber",
    dataIndex: "versionNumber",
    tableItem: {},
  },
  {
    title: "状态",
    name: "status",
    dataIndex: "status",
    tableItem: {},
    dict: [
      { code: 0, codeName: "已申请" },
      { code: 1, codeName: "已确认申请" },
      { code: 2, codeName: "已取消申请" }
    ],
  },
  {
    title: "申请人",
    name: "applicantFullNameSearch",
    dataIndex: "applicantFullNameSearch",
    searchItem: {},
  },
  {
    title: "申请人",
    name: "applicantFullName",
    dataIndex: "applicantFullName",
    tableItem: {}
  },
  {
    title: '申请时间',
    name: 'applicationTime',
    dataIndex: 'applicationTime',
    searchItem: {
      type: 'date~',
      showTime: true,
    },
  },
  {
    title: '处理申请时间',
    name: 'processingApplicationsTime',
    dataIndex: 'processingApplicationsTime',
    searchItem: {
      type: 'date~',
      showTime: true,
    },
  },
  {
    title: "培训公司",
    name: "trainCompanyNameSearch",
    dataIndex: "trainCompanyNameSearch",
    searchItem: {},
  },
  {
    title: "培训公司",
    name: "trainCompanyName",
    dataIndex: "trainCompanyName",
    tableItem: {}
  },
  {
    title: "申请时间",
    name: "createTime",
    dataIndex: "createTime",
    tableItem: {}
  },
  {
    title: "修改申请时间",
    name: "applyTime",
    dataIndex: "applyTime",
    tableItem: {}
  },

  {
    title: "处理申请时间",
    name: "handleTime",
    dataIndex: "handleTime",
    tableItem: {}
  },
  {
    title: "状态",
    name: "status",
    dataIndex: "status",
    dict: [
      { code: 0, codeName: "已申请" },
      { code: 1, codeName: "已确认申请" },
      { code: 2, codeName: "已取消申请" }
    ],
    searchItem: {
      type: "select"
    },
  },
];

const templateConfig = (data) => {
  const { self } = data;
  let valueRows = []

  const surveyTempConfig = WizTableForm.Config.programByApplication(self, { apiParams: { status: 1, versionFilter: 1 } })
  let tableFormProps = {
    showModal: false,
    visible: true,
    selectType: 'radio',
    width: 900,
    initRows: [],
    value: [],
    onSubmit: self._addSurveyByTempSubmit,
    onCancel: self._onCancelTemp,
  }

  const _renderBtn = (value, valueRowList) => {
    if (value && value > 0) {
      value = value[0]
    }
    valueRows = valueRowList
  }
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns,
        searchBarProps: {
          dataFormat: (v) => {
            let value = Object.assign([], v)
            if (value['applicationTime'] && value['applicationTime'].length === 2) {
              value['createTimeStart'] = moment(value['applicationTime'][0]).format('YYYY-MM-DD HH:mm:00')
              value['createTimeEnd'] = moment(value['applicationTime'][1]).format('YYYY-MM-DD HH:mm:00')
            } else {
              value['createTimeStart'] = ''
              value['createTimeEnd'] = ''
            }
            if (value['processingApplicationsTime'] && value['processingApplicationsTime'].length === 2) {
              value['handleTimeStart'] = moment(value['processingApplicationsTime'][0]).format('YYYY-MM-DD HH:mm:00')
              value['handleTimeEnd'] = moment(value['processingApplicationsTime'][1]).format('YYYY-MM-DD HH:mm:00')
            } else {
              value['handleTimeStart'] = ''
              value['handleTimeEnd'] = ''
            }
            return value
          },
          cols: {
            xs: 12,
            md: 12,
            xl: 8
          },
          buttonSort: ['group', "export"],
          buttons: [
            {
              key: 'group',
              type: 'group',
              params: { icon: 'down', children: '申请', type: 'primary' },
              options: [
                {
                  key: 'newCourseApplication',
                  custom: true,
                  params: { children: '新课程申请' },
                  customOnClick: {
                    key: 'jumpPage',
                    params: {
                      key: 'push',
                      pathname: '/course/applicationDetailAdd',
                      record: { code: 0 }
                    },
                  }
                },
                {
                  key: 'courseUpdateApplication',
                  name: "WizButton",
                  params: {
                    children: '课程更新申请'
                  },
                  customOnClick: {
                    key: "modal",
                    params: {
                      modalParams: {
                        title: "选择需要更新的课程",
                        diy: (e) => {
                          console.log(e, 'eeee')
                          return <>
                            <WizTableForm   {...surveyTempConfig} {...tableFormProps} renderValue={_renderBtn}>
                            </WizTableForm>
                          </>
                        },
                        onOk: (obj, e) => {
                          self._addSurveyByTempSubmit({ valueRows: valueRows })
                        },
                        onCancel: () => {
                          self._onCancelTemp()
                        },
                        width: 900
                      }
                    }
                  }
                },
              ]
            },
            {
              key: 'export',
              custom: true,
              params: { icon: 'export', children: '导出', type: 'export' },
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "export",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return { ...filters }
                }
              }
            }
          ]
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: "id",
          // selectType: "checkbox",
          isScroll: true,
          loading: false,
        },
        rowOperateSort: ['look', 'createCourse', 'modifyApplication', 'confirmApplication', 'withdraw'],
        rowOperateView: [
          {
            custom: true,
            key: 'look',//课程查看
            name: 'WizButton',
            params: {
              children: '查看',
              key: 'look',
            },
            customOnClick: {},

            recordChangeParams: ({ record, rows }) => {

              let is = record.applyType == 2
              return {
                disabled: is, onClick: (e) => { self.lookJump && self.lookJump(record) },

              }
            },
          },
          {
            custom: true,
            key: "modifyApplication",
            name: 'WizButton',
            params: {
              children: '修改申请',
              key: 'modifyApplication',

            },
            customOnClick: {},
            recordChangeParams: ({ record, rows }) => {

              let is = record.status !== 0
              return {
                disabled: is,
                onClick: () => { self.editApplication && self.editApplication(record) },
              }
            },
          },
          {
            key: "createCourse",
            custom: true,
            params: { children: "创建课程" },
            customOnClick: {
              key: "action",
              params: {
                apiKey: "operate",
                apiParams: {}
              },
              formatParams: (rows, record, filter, callback) => {
                const content = <div>
                  您正在创建此申请的在线课程，是否确认？
                </div>
                WizModal.confirm({
                  title: '信息确认',
                  content: content,
                  width: 500,
                  onOk: () => {
                    callback && callback({
                      id: record['id'],
                      operateStatus: 0
                    })
                  },
                  onCancel() {
                  }
                });
                return null
              }
            },
            recordChangeParams: ({ record, rows }) => {
              let is = record.status !== 0 || record.programId
              return { disabled: is }
            },
          },
          {
            key: "confirmApplication",
            custom: true,
            params: { children: "确认申请" },
            customOnClick: {
              key: "action",
              params: {
                apiKey: "operate",
                apiParams: {}
              },
              formatParams: (rows, record, filter, callback) => {
                const content = <div>
                  您正在做确认申请操作，是否确定？
                </div>
                WizModal.confirm({
                  title: '信息确认',
                  content: content,
                  width: 500,
                  onOk: () => {
                    callback && callback({
                      id: record['id'],
                      operateStatus: 1
                    })
                  },
                  onCancel() {
                  }
                });
                return null
              }
            },
            recordChangeParams: ({ record, rows }) => {
              let is = record.status !== 0 || !record.programId
              return { disabled: is }
            },
          },
          {
            key: "withdraw",
            custom: true,
            params: { children: "取消申请" },
            customOnClick: {
              key: "action",
              params: {
                apiKey: "operate",
                apiParams: {}
              },
              formatParams: (rows, record, filter, callback) => {
                const content = <div>
                  您正在做取消申请操作，是否确定？
                </div>
                WizModal.confirm({
                  title: '信息确认',
                  content: content,
                  width: 500,
                  onOk: () => {
                    callback && callback({
                      id: record['id'],
                      operateStatus: 2
                    })
                  },
                  onCancel() {
                  }
                });
                return null
              }
            },
            recordChangeParams: ({ record, rows }) => {
              let is = record.status !== 0
              return { disabled: is }
            },
          },
          {
            key: "releaseOrClose",
            custom: true,
            params: { children: "发布" },
            textFormat: {
              recordKey: 'status',
              dirt: { 2: '发布', 1: '关闭', 0: "发布" }
            },
            customOnClick: {
              key: "action",
              params: {
                apiKey: "UpdateProgramStatus",
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                const content = `您确定要${record['status'] === 1 ? "关闭" : "发布"
                  }该课程吗？`;
                WizModal.confirm({
                  title: '注意', content,
                  onOk: () => {
                    callback && callback({
                      status: record['status'] === 1 ? 2 : 1,
                      idList: [record['id']]
                    })
                  },
                  onCancel() {
                  }
                });
                return null
              }
            }
          },
          {
            key: 'advancedSet',
            custom: true,
            params: { children: '高级设置' },
            customOnClick: {
              key: 'modal',
              params: {
                modalParams: {
                  title: '高级设置',
                  bordered: true,
                  footer: null,
                  destroyOnClose: true,
                  diy: (e) => {
                    return <>
                      <HighSet data={{ record: e.record, bizType: 0 }}
                        changeModal={e.changeModal}
                      />
                    </>
                  },
                  width: 950
                },
              }
            },
            recordChangeParams: ({ record, rows }) => {
              let disabled = false
              if (record && record['status'] === 2) {
                disabled = true
              }
              return { disabled }
            }
          },
          {
            key: "QRCode",
            custom: true,
            params: { children: "二维码" },
            customOnClick: {
              key: 'modal',
              params: {
                modalParams: {
                  title: '课程二维码',
                  footer: null,
                  destroyOnClose: true,
                  diy: (e) => {
                    return <>
                      <h2 align="center">{e.record.name}</h2>
                      <div align='center' style={{ paddingBottom: 20 }}>
                        <QRCode
                          style={{ margin: 20 }}
                          id="qrCode"
                          value={constants.env.sys_get_app_link(`sgmlms://sgmlms/programDetail/${e.record.id}`)}
                          fgColor="#000000" // 二维码的颜色
                        />
                        <br />
                        <a style={{ borderRadius: 3, borderWidth: 1, borderStyle: 'solid', borderColor: '#6faff8', padding: 8 }} id='down_link' onClick={this._downQrCode}>下载二维码</a>
                      </div>
                    </>
                  }
                }
              }
            },
            recordChangeParams: ({ record, rows }) => {
              let disabled = true
              if (record && record['status'] === 1) {
                disabled = false
              }
              return { disabled }
            }
          },
          {
            key: "evaluationManagement",
            custom: true,
            params: { children: "评价管理" },
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: "/program/programList/programEvaluation"
              }
            }
          },
          {
            key: 'authSetting',
            custom: true,
            params: { children: '受众设置' },
            customOnClick: {
              key: 'modal',
              params: {
                modalParams: {
                  title: '受众设置',
                  bordered: true,
                  footer: null,
                  destroyOnClose: true,
                  diy: (e) => {
                    return <>
                      <WizDataAuthSelect
                        value={e.record.authData}
                        onSubmit={(values) => { self._saveAuth(values, e.changeModal) }}
                        bizType={0}
                        bizId={e.record.id}
                        changeModal={e.changeModal}
                      />
                    </>
                  },
                  width: 950
                },
              }
            },
            recordChangeParams: ({ record, rows }) => {
              return true
            }
          },
        ],
        commonOperate: {
        },
      }
    }
  }
};

const apis = {
  list: {
    path: `${componentName}/getListByPage`,
    payload: {
      key: `${componentName}@listByPage`,
      apiParams: { pageNum: 1, pageSize: 10 }
    }
  }
  ,
  operate: {
    path: `${componentName}/operate`,
    payload: {
      key: `${componentName}@operate`,
      apiParams: {}
    }
  },
  add: {
    path: `${componentName}/add`,
    payload: {
      key: `${componentName}@add`,
      apiParams: {}
    }
  },
  update: {
    path: `${componentName}/update`,
    payload: {
      key: `${componentName}@update`,
      apiParams: {}
    }
  },
  delete: {
    path: `${componentName}/delete`,
    payload: {
      key: `${componentName}@delete`,
      apiParams: {}
    }
  },
  UpdateProgramStatus: {
    path: `${componentName}/UpdateProgramStatus`,
    payload: {
      key: `${componentName}@UpdateProgramStatus`,
      apiParams: {}
    }
  },
  export: {
    path: `${componentName}/export`,
    payload: {
      key: `${componentName}@export`,
      apiParams: {}
    }
  }

}


let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
};

export { reduxTemplateCofig, templateConfig };
